module.exports = __webpack_public_path__ + "img/Bernd Leno.0fc60e92.png";